import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';

import tagsConfigHelper from '../../../helpers/tagsConfigHelper'
import ControlManager from '../ControlManager'
import {
    START_VALIDATE_TAGS,
    ADD_TAG_ERROR
} from '../../../redux/actions/actionTypes'

class InputDecimalIR extends PureComponent {
    constructor(props) {
        super(props)

        this.state ={}

        this.initState=this.initState.bind(this)

        this.initState()

        // window.emitter.addListener(START_VALIDATE_TAGS, function (message) {
        //     validate()
        // })
    }

    initState(){
        let {doctype}=this.props

        this.state={
            visible: true,
            disabled: (!doctype || doctype=="")?this.props.disabled:false,
            required:false,
            description:null,
            error:false,
            error_message:null,

            input: "",
            start: 0,
        }
    }

    onChange(event){
        const maxDigits = 13
        let { start}  = this.state
        const { floatingPoint } = this.props
        start = event.target.selectionStart;
        let val = event.target.value;
        val = val.replace(/,/g, "");
        val = val.replace(/([^0-9.]+)/, "");
        val = val.replace("..", ".");
        if((val !== '0') && (val !== '0.'))
            val = val.replace(/^(0|\.)/, "");
        // const match = /(\d{0,13})[^.]*((?:\.\d{0,2})?)/g.exec(val);
        
        var regEx = new RegExp(`(\\d{0,${maxDigits}})[^.]*((?:\\.\\d{0,${floatingPoint}})?)`, "g");
        const match = regEx.exec(val);
        const value = match[1] + match[2];
        event.target.value = value;
        this.setState({ input: value });
        if (val.length > 0) {
          event.target.value = Number(value).toFixed(floatingPoint);
          event.target.setSelectionRange(start, start);
          this.setState({ input: Number(value).toFixed(floatingPoint) });
        }

        this.props.onChange && this.props.onChange(event)
      };

    render() {
        let { disabled, visible } = this.state

        return (
            <input
                {...this.props}
                className={['form-control', this.props.className].join(' ')}
                disabled={this.props.disabled || this.props.viewMode ? "disabled" : null}
                style={{ visibility: visible ? "visible" : "hidden" }}
                onChange={(event) => this.onChange(event)}
                maxLength="13"
            />
        )
    }    
}

InputDecimalIR.defaultProps = {
    type: "text",
    floatingPoint: 2,
}

// InputDecimalIR.propTypes = {
//     doctype: PropTypes.string,
//     tagid: PropTypes.string,
//     floatingPoint: PropTypes.number,
// }

export default InputDecimalIR